module.exports = __webpack_public_path__ + "img/86.7.Chla.563fad1c.png";